export const GENERIC_PAGE_SIZE = 9
